import { ConversationItemParts, ConversationReadingPaneNode, mailStore } from 'owa-mail-store';
import { ObservableMap } from 'mobx';
import tryRemoveFromMailStoreItems, {
    RemoveItemSource,
} from 'owa-mail-actions/lib/triage/tryRemoveFromMailStoreItems';
import Item from 'owa-service/lib/contract/Item';
import { action, select } from 'satcheljs/lib/legacy';
import { onDeleteConversationItemPartsComplete } from 'owa-mail-actions/lib/mailTriageActions';

export interface DeleteConversationItemPartsState {
    conversations: ObservableMap<string, ConversationItemParts>;
    conversationNodes: ObservableMap<string, ConversationReadingPaneNode>;
    items: ObservableMap<string, Item>;
}

export default action('deleteConversationItemParts')(
    select<DeleteConversationItemPartsState>({
        conversations: () => mailStore.conversations,
        conversationNodes: () => mailStore.conversationNodes,
        items: () => mailStore.items,
    })(function deleteConversationItemParts(
        conversationId: string,
        state?: DeleteConversationItemPartsState
    ) {
        if (state.conversations.has(conversationId)) {
            const conversationItemParts = state.conversations.get(conversationId);
            for (const conversationNodeId of conversationItemParts.conversationNodeIds) {
                const conversationNode = state.conversationNodes.get(conversationNodeId);
                for (const itemId of conversationNode.itemIds) {
                    tryRemoveFromMailStoreItems(itemId, RemoveItemSource.ConversationItemParts);
                }
                state.conversationNodes.delete(conversationNodeId);
            }

            state.conversations.delete(conversationId);
        }

        onDeleteConversationItemPartsComplete();
    })
);
